import styled from '@emotion/styled';
import { easeOpacity } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

export const MainTableWrapper = styled('table', { label: 'MainTableWrapper' })`
    border-spacing: 0;
`;

export const MainTableHeaderRow = styled('tr', { label: 'MainTableHeaderRow' })`
    background: #fff;
    border: none !important;
`;

export const MainTableHeaderCell = styled('th', { label: 'MainTableHeaderCell' })`
    color: #141922;
    font-size: 10px;
    font-weight: bold;
    height: 32px;
    line-height: 1.2;
    padding: 3px 7px 3px 8px;
    position: relative;
    &::after {
        border-right: 1px solid #f6f9fc;
        bottom: 4px;
        content: '';
        position: absolute;
        right: 0;
        top: 4px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const MainTableBodyRow = styled('tr', { label: 'MainTableBodyRow' })`
    background: #fff;
    border: none;
    position: relative;
    &:nth-of-type(odd) {
        background: #f6f9fc;
    }
`;

export const MainTableBodyCell = styled('td', { label: 'MainTableBodyCell' })`
    color: #141922;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.1667;
    padding: 9px 8px !important;
    position: relative;
    text-align: left;
    &::after {
        border-right: 1px solid #fff;
        bottom: 4px;
        content: '';
        position: absolute;
        right: 0;
        top: 4px;
    }
    &:last-of-type {
        &::after {
            content: none;
        }
    }
`;

export const MainTableLink = styled('a', { label: 'MainTableLink' })`
    color: #3d76ca;
    font-weight: 600;
    position: relative;
    text-decoration: none;
    &::before {
        background: currentColor;
        content: '';
        height: 1px;
        margin-top: -1px;
        opacity: 1;
        position: absolute;
        top: 100%;
        transition: ${easeOpacity};
        width: 100%;
    }
    &:hover {
        &::before {
            opacity: 0;
        }
    }
`;

export const MainTableFakeLink = styled('button', { label: 'MainTableFakeLink' })`
    color: #3d76ca;
    font-weight: 600;
    position: relative;
    text-decoration: none;
    &::before {
        background: currentColor;
        content: '';
        height: 1px;
        margin-top: -1px;
        opacity: 1;
        position: absolute;
        top: 100%;
        transition: ${easeOpacity};
        width: 100%;
    }
    &:hover {
        &::before {
            opacity: 0;
        }
    }
`;

